import React, { useEffect, useState } from 'react';
import { Container } from './styles';
import { Tab } from '@gerdau/hefesto';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { TabItemProps } from '@gerdau/hefesto/Tab/Tab.types';
import NFTabContent from '../DownloadAreaTabs/NFTabContent';
import BilletTabContent from './BilletTabContent';
import QualityCertificateTabContent from './QualityCertificateTabContent';

enum EDownloadAreaTabs {
  NFS = 'NFS',
  BILLETS = 'BILLETS',
  QUALITY_CERTIFICATE = 'QUALITY_CERTIFICATE'
}

const DownloadAreaTabs: React.FC = () => {
  const userState = useSelector((appState: ApplicationState) => appState.user);
  const downloadAreaState = useSelector(
    (appState: ApplicationState) => appState.downloadArea
  );

  const [selectedTab, setSelectedTab] = useState<EDownloadAreaTabs>();

  const onChangeTab = (newTab: EDownloadAreaTabs) => {
    setSelectedTab(newTab);
  };

  const [availableTabs, setAvailableTabs] = useState<TabItemProps[]>();

  const initAvailableTabs = () => {
    const tabs: TabItemProps[] = [];
    const {
      financialCustomers,
      ordersViewCustomers,
      ordersViewPriceCustomers
    } = userState.roles;

    const selectedCustomer = downloadAreaState.customerId;
    const canViewFinancials =
      financialCustomers.includes(selectedCustomer) || userState.isManager;
    const canViewOrders =
      ordersViewCustomers.includes(selectedCustomer) || userState.isManager;
    const canViewPrices =
      ordersViewPriceCustomers.includes(selectedCustomer) ||
      userState.isManager;

    if (canViewOrders && canViewPrices) {
      tabs.push({
        key: EDownloadAreaTabs.NFS,
        name: 'Nota fiscal',
        content: <NFTabContent />
      });
    }

    if (canViewFinancials) {
      tabs.push({
        key: EDownloadAreaTabs.BILLETS,
        name: '2a via de boleto',
        content: <BilletTabContent />
      });
    }

    if (canViewOrders) {
      tabs.push({
        key: EDownloadAreaTabs.QUALITY_CERTIFICATE,
        name: 'Certificado de qualidade',
        content: <QualityCertificateTabContent />
      });
    }

    setAvailableTabs(tabs);

    if (tabs.length > 0) {
      setSelectedTab(tabs[0].key as EDownloadAreaTabs);
    }
  };

  useEffect(() => {
    initAvailableTabs();
  }, [downloadAreaState.customerId]);

  return (
    <Container>
      <Tab
        tabItems={availableTabs || []}
        activeKey={selectedTab || ''}
        onChange={(newTab) => onChangeTab(newTab as EDownloadAreaTabs)}
      />
    </Container>
  );
};

export default DownloadAreaTabs;
